import { RadioProps } from '@mui/material';
import Alert from '@mui/material/Alert';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export type StyledRadioProps = RadioProps & {
  label?: ReactNode;
  subLabel?: ReactNode;
};

export function StyledRadio({ label, subLabel, ...props }: StyledRadioProps) {
  return (
    <Alert
      component="label"
      icon={
        <Radio
          sx={{ margin: -1 }}
          color="secondary"
          checkedIcon={<CheckCircleIcon />}
          {...props}
        />
      }
      variant="outlined"
      sx={{
        fontSize: '1rem',
        cursor: 'pointer',
        borderWidth: 1,
        borderColor: props.checked ? 'secondary.main' : 'divider',
        borderStyle: 'solid',
        color: 'text.primary',
        flex: 1,
        py: 0,
        px: 1
      }}
    >
      <Typography>{label}</Typography>
      <Typography variant="body2" color="text.secondary">
        {subLabel}
      </Typography>
    </Alert>
  );
}
